import React from 'react';
import SmartVideoPlayer from './smart-video-player.component';
import SlidePanel from './slide-panel.component';
import { SlideSection } from '../../utils/slide-panel.utils';
import { VideoMoment } from '../../utils/video-moments.utils';
import styles from './video-analytics.module.scss';

type Props = {
  videoUrl: string;
  durationSec: number;
  currentTime: number;
  markers: VideoMoment[];
  sections: SlideSection[];
  getThumbUrl: (slideIndex: number) => string;
  onTimeChange: (time: number) => void;
  onDurationChange: (duration: number) => void;
  onPlayingChange?: (playing: boolean) => void;
  onSeek: (time: number) => void;
  seekRef?: React.MutableRefObject<((time: number) => void) | null>;
  togglePlayPauseRef?: React.MutableRefObject<(() => void) | null>;
  slidesAnalyzing?: boolean;
  onAnalyzeSlides?: () => void;
};

/** Layout: grid 1.6fr | 1fr — плеер слева, панель слайдов справа */
const PlayerSlidePanel: React.FC<Props> = ({
  videoUrl,
  durationSec,
  currentTime,
  markers,
  sections,
  getThumbUrl,
  onTimeChange,
  onDurationChange,
  onPlayingChange,
  onSeek,
  seekRef,
  togglePlayPauseRef,
  slidesAnalyzing,
  onAnalyzeSlides,
}) => (
  <div className={styles.playerSlideGrid}>
    <SmartVideoPlayer
      videoUrl={videoUrl}
      durationSec={durationSec}
      currentTime={currentTime}
      markers={markers}
      onTimeChange={onTimeChange}
      onDurationChange={onDurationChange}
      onPlayingChange={onPlayingChange}
      onSeek={onSeek}
      seekRef={seekRef}
      togglePlayPauseRef={togglePlayPauseRef}
      embedded
    />
    <SlidePanel
      sections={sections}
      currentTime={currentTime}
      getThumbUrl={getThumbUrl}
      onSeek={onSeek}
      slidesAnalyzing={slidesAnalyzing}
      onAnalyzeSlides={onAnalyzeSlides}
    />
  </div>
);

export default PlayerSlidePanel;
